import { FC } from 'react';
import { IconProps } from '../../types';

export const YandexIcon: FC<IconProps> = ({ width = 24, height = 24, ...props }) => {
  return (
    <svg width={width} height={height} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M12 0C18.6268 0 24 5.37323 24 12C24 18.6268 18.6268 24 12 24C5.37323 24 0 18.6268 0 12C0 5.37323 5.37323 0 12 0Z'
        fill='#FC3F1D'
      />
      <path
        d='M13.6657 18.5034H16.1727V4.10615H12.5252C8.85769 4.10282 6.92918 5.98811 6.92918 8.7645C6.92918 10.9823 7.98653 12.2857 9.87182 13.6324L6.6 18.5001H9.31322L12.9574 13.0505L11.6939 12.2026C10.1611 11.1685 9.41629 10.3605 9.41629 8.6182C9.41629 7.08537 10.4936 6.04796 12.5451 6.04796H13.6624L13.6657 18.5034Z'
        fill='white'
      />
    </svg>
  );
};
